import moment from 'moment';
import React from 'react';

export const CalendarDays = () => {
    const weekdays = moment.weekdaysShort();

    return (
        <tr>
            {weekdays.map((day) => (
                <th className="datepicker-day-heading" key={day}>
                    {day}
                </th>
            ))}
        </tr>
    );
};
